export default {
  options: {
    units: {
      kilometers: 'Kilômetros',
      meters: 'Metros',
      miles: 'Milhas'
    },
    areUnits: {
      sqKms: 'km²',
      hectare: 'Hectare',
      sqMeters: 'm²'
    }
  }
}
